module.exports = __webpack_public_path__ + "575af683e2dea53dca055eeb11fb6759.svg";